/**
 * Convert a YouTube or Vimeo watch/share URL into an embeddable iframe URL.
 * Returns null when the URL is empty or not a recognised YouTube/Vimeo video
 * (e.g. a raw .mp4 link, which cannot be embedded via iframe).
 *
 * Supported YouTube forms: watch?v=, youtu.be/, embed/, shorts/, live/, v/,
 * with any sub-domain (www/m/music) and any trailing/leading query params.
 * Supported Vimeo forms: vimeo.com/ID, player.vimeo.com/video/ID,
 * vimeo.com/channels/<x>/ID, vimeo.com/groups/<x>/videos/ID.
 */
export function getVideoEmbedUrl(url: string | undefined): string | null {
  if (!url) return null;
  const trimmed = url.trim();
  if (!trimmed) return null;

  const yt = trimmed.match(
    /(?:youtube\.com\/(?:watch\?(?:[^#]*&)?v=|embed\/|shorts\/|live\/|v\/)|youtu\.be\/)([\w-]{11})/
  );
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;

  const vimeo = trimmed.match(
    /vimeo\.com\/(?:video\/|channels\/[^/]+\/|groups\/[^/]+\/videos\/)?(\d+)/
  );
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`;

  return null;
}
